import { Button } from 'antd';
import axios from 'axios';
import { useEffect, useState } from 'react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useTypedSelector } from '../../hooks/useTypedSelector';
import { pages } from '../../routes/Routes.constants';
import { PagesTypes } from '../../routes/Routes.interfaces';
import { UserStatus } from '../Registration/Registration.interfaces';

export const Home = () => {
  const { userInfo } = useTypedSelector((state) => state.registration);
  const navigate = useNavigate();

  useEffect(() => {
    if (userInfo?.status !== UserStatus.ACTIVE) {
      navigate(pages[PagesTypes.DOC].path);
    }
  }, [navigate, userInfo]);

  return (
    <div>
      <h1>Вы прошли регистрацию</h1>
      <div>{userInfo?.name}</div>
    </div>
  );
};
